import { ActiveCartItem } from 'types/cart';

export const isAppOnlyProductItem = (item: ActiveCartItem) =>
  item.__typename === 'ProductCartItem' && !!item.product.isAppExclusive;
